import React, {useEffect} from 'react'
import PropTypes from 'prop-types'

const Script = ({src, id, async = true, defer = false, delayUntilIdle = false, attributes = {}, onLoad, onError}) => {
    useEffect(() => {
        if (!src) return

        const scriptId = id || `script-${btoa(src)}`

        if (document.getElementById(scriptId)) {
            return
        }

        const loadScript = () => {
            const script = document.createElement('script')
            script.id = scriptId
            script.nonce = window.__CSP_NONCE__
            script.src = src
            script.async = async
            script.defer = defer

            Object.entries(attributes).forEach(([key, value]) => {
                script.setAttribute(key, value)
            })

            if (onLoad) {
                script.onload = onLoad
            }

            if (onError) {
                script.onerror = onError
            }

            document.head.appendChild(script)
        }

        let idleCallbackId
        let timeoutId

        if (delayUntilIdle) {
            // Use requestIdleCallback if available, fallback to setTimeout
            if ('requestIdleCallback' in window) {
                idleCallbackId = window.requestIdleCallback(loadScript, {timeout: 3000})
            } else {
                timeoutId = setTimeout(loadScript, 2000)
            }
        } else {
            loadScript()
        }

        return () => {
            if (idleCallbackId && 'cancelIdleCallback' in window) {
                window.cancelIdleCallback(idleCallbackId)
            }
            if (timeoutId) {
                clearTimeout(timeoutId)
            }
            const existingScript = document.getElementById(scriptId)
            if (existingScript) {
                existingScript.remove()
            }
        }
    }, [src, id, async, defer, delayUntilIdle, attributes, onLoad, onError])

    return null
}

Script.propTypes = {
    src: PropTypes.string.isRequired,
    id: PropTypes.string,
    async: PropTypes.bool,
    defer: PropTypes.bool,
    delayUntilIdle: PropTypes.bool,
    attributes: PropTypes.object,
    onLoad: PropTypes.func,
    onError: PropTypes.func
}

export default Script
